import {isMacOs} from 'react-device-detect';

export interface KeyboardShortcutsViewProps {
  onBack: () => void;
}

export enum KeyKind {
  CHAR = 'char',
  STRING = 'string',
}

export interface ShortcutKey {
  kind: KeyKind;
  display: string;
}

export interface ShortcutRowConfig {
  labelKey: string;
  keys: ShortcutKey[];
}

export interface ShortcutSectionConfig {
  titleKey: string;
  rows: ShortcutRowConfig[];
}

const MOD_KEY: ShortcutKey = isMacOs ? {kind: KeyKind.CHAR, display: '⌘'} : {kind: KeyKind.STRING, display: 'Ctrl'};
const SHIFT_KEY: ShortcutKey = {kind: KeyKind.STRING, display: 'Shift'};
const ESC_KEY: ShortcutKey = {kind: KeyKind.STRING, display: 'Esc'};
const TAB_KEY: ShortcutKey = {kind: KeyKind.STRING, display: 'Tab'};
const Z_KEY: ShortcutKey = {kind: KeyKind.CHAR, display: 'Z'};

export const KEYBOARD_SHORTCUT_SECTIONS: ShortcutSectionConfig[] = [
  {
    titleKey: 'pmwjs_general',
    rows: [
      {labelKey: 'pmwjs_undo', keys: [MOD_KEY, Z_KEY]},
      {labelKey: 'pmwjs_redo', keys: [MOD_KEY, SHIFT_KEY, Z_KEY]},
      {labelKey: 'pmwjs_deselection', keys: [ESC_KEY]},
      {labelKey: 'pmwjs_select_next_item', keys: [TAB_KEY]},
      {labelKey: 'pmwjs_select_previous_item', keys: [SHIFT_KEY, TAB_KEY]},
    ],
  },
];
